/**
 * @file DashboardProgress.jsx
 * @author Daniel Aguirre
 * @description Dashboard Progress
 */

// Dependencies
import { Progress } from 'antd';
import PropTypes from 'prop-types';
import EmptyChart from 'components/EmptyChart';
import { isEmpty } from 'lodash';
import DashboardFilter from '../DashboardFilter';
import DashboardTitle from '../DashboardTitle';

const DashboardProgress = ({
  title,
  max,
  progress,
  description,
  selectMenu,
  onDetailClick,
  isTitleBold = true
}) => {
  const onProgressClick = (position) => {
    if (onDetailClick) {
      onDetailClick(position);
    }
  };
  return (
    <>
      {title && (
        <DashboardTitle
          title={title}
          isTitleBold={isTitleBold}
          description={description}
          descriptionProgress>
          {selectMenu && (
            <DashboardFilter
              menuItems={selectMenu?.menu?.items}
              label={selectMenu?.menu?.label}
              onSelectItem={selectMenu?.onSelectItem}
              current={selectMenu?.current}
            />
          )}
        </DashboardTitle>
      )}
      <div
        className="m-auto border-round-5 text-baxterGray"
        style={{ height: '291' }}>
        <div className="mt-10">
          {!isEmpty(progress) && (
            <span
              className="float-left cursor-pointer"
              onClick={() => onProgressClick('progress')}>
              {progress?.title ? (
                <>
                  <strong>{progress?.title}</strong> {progress?.label}
                </>
              ) : (
                <>
                  <strong>{progress?.value}%</strong> {progress?.label}
                </>
              )}
            </span>
          )}
          {!isEmpty(max) && max?.label && (
            <span
              className="float-right cursor-pointer"
              onClick={() => onProgressClick('max')}>
              {max?.title ? (
                <>
                  <strong>{max?.title}</strong> {max?.label}
                </>
              ) : (
                <>
                  <strong>{max?.value}%</strong> {max?.label}
                </>
              )}
            </span>
          )}
          {isEmpty(max) && isEmpty(progress) ? (
            <EmptyChart />
          ) : (
            <Progress
              onClick={(e) => {
                const position = e.target.className;
                if (position === 'ant-progress-bg') {
                  onProgressClick('progress');
                } else if (!isEmpty(max) && max?.label) {
                  onProgressClick('max');
                }
              }}
              className="cursor-pointer"
              strokeLinecap="square"
              strokeWidth={20}
              showInfo={false}
              strokeColor={progress?.color}
              trailColor={max?.color}
              percent={progress?.value}
            />
          )}
        </div>
      </div>
    </>
  );
};

/**
 * Component definition of proptypes.
 */
DashboardProgress.propTypes = {
  title: PropTypes.string,
  max: PropTypes.object,
  progress: PropTypes.object,
  description: PropTypes.string,
  selectMenu: PropTypes.object,
  onDetailClick: PropTypes.func,
  isTitleBold: PropTypes.bool
};
export default DashboardProgress;
